module.exports = __webpack_public_path__ + "media/images/durst_logo-d8363fff9d6949cd709dcec18202b7e0.png";